module.exports = __webpack_public_path__ + "img/welcone.c088b715.png";